import { createRequestTypes } from '../utils';

// export const RAWMAT_PROPORTION_LIST = createRequestTypes('rawMatProportion/RAWMAT_PROPORTION_LIST');
export const ADD_RAWMAT_PROPORTIONS_FROM_RAWMAT = createRequestTypes(
  'rawMatProportion/ADD_RAWMAT_PROPORTIONS_FROM_RAWMAT',
);
export const DELETE_RAWMAT_PROPORTION = createRequestTypes('rawMatProportion/DELETE_RAWMAT_PROPORTION');
export const SAVE_RAWMAT_PROPORTIONS = createRequestTypes('rawMatProportion/SAVE_RAWMAT_PROPORTIONS');
export const FETCH_RAWMAT_PROPORTIONS = createRequestTypes('rawMatProportion/FETCH_RAWMAT_PROPORTIONS');
